import { render, staticRenderFns } from "./ListRole.vue?vue&type=template&id=5e105a0d&"
import script from "./ListRole.vue?vue&type=script&lang=js&"
export * from "./ListRole.vue?vue&type=script&lang=js&"
import style0 from "./ListRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports